import toastr from 'toastr';
import '@/../node_modules/toastr/build/toastr.css';

export function err(message: string) {
    toastr.error(message);
}

export function warn(message: string) {
    toastr.warning(message);
}

export function success(message: string) {
    toastr.success(message);
}
